export const onChangeEventHandler = (
  e: React.ChangeEvent<HTMLInputElement>,
  disabled: boolean,
  eventCallback: (e: React.ChangeEvent<HTMLInputElement>) => void
) => {
  if (disabled) {
    e.preventDefault();
    return;
  }
  eventCallback(e);
};

export const onMouseEventHandler = (
  e: React.MouseEvent<HTMLInputElement | HTMLButtonElement, MouseEvent>,
  disabled: boolean,
  eventCallback: (
    e: React.MouseEvent<HTMLInputElement | HTMLButtonElement, MouseEvent>
  ) => void
) => {
  if (disabled) {
    e.preventDefault();
    return;
  }
  eventCallback(e);
};

export const onClickEventHandler = (
  e: React.MouseEvent<HTMLSelectElement, MouseEvent>,
  disabled: boolean,
  eventCallback: (e: React.MouseEvent<HTMLSelectElement, MouseEvent>) => void
) => {
  if (disabled) {
    e.preventDefault();
    return;
  }
  eventCallback(e);
};

export const onKeyDownEventHandler = (
  e: React.KeyboardEvent<HTMLSelectElement>,
  disabled: boolean,
  eventCallback: (e: React.KeyboardEvent<HTMLSelectElement>) => void
) => {
  if (disabled && e.key !== 'Tab') {
    e.preventDefault();
    return;
  }
  eventCallback(e);
};

export const onMouseDownEventHandler = (
  e: React.MouseEvent<HTMLSelectElement, MouseEvent>,
  disabled: boolean,
  eventCallback: (e: React.MouseEvent<HTMLSelectElement, MouseEvent>) => void
) => {
  if (disabled) {
    e.preventDefault();
    return;
  }
  eventCallback(e);
};
